<!--Modals-->
<ui-dialog
    size="small"
    [open]="isRequestDaysDialogOpen"
    [form]="requestDaysForm.form"
    header="{{ 'time-off-v3.adjustDailyAmounts' | translate }}"
    (primaryButtonPressed)="onSaveRequestDays(requestDaysForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="closeDialog()"
    secondaryButtonLabel="cancel"
    (closing)="closeDialog()"
    [stickyButtons]="true"
    [stickyHeader]="true"
>
    <app-request-days-form
        [timeOffRequest]="timeOffRequest"
        #requestDaysForm
        [maxAmount]="maxAmount"
    ></app-request-days-form>
</ui-dialog>

<div class="time-off-request" *ngIf="!isLoading">
    <div class="banners" *ngIf="hasBanner">
        <ui-banner variant="info" *ngIf="!!selectedTimeOffPolicy.timeOffType.description">
            <p>
                {{ 'time-off-v3.noteFromAdmin' | translate: { note: selectedTimeOffPolicy.timeOffType.description } }}
            </p>
        </ui-banner>
        <ui-banner variant="warning" *ngFor="let warning of warnings">
            <p>{{ warning | translate }}</p>
        </ui-banner>
        <ui-banner variant="danger" *ngFor="let error of errors">
            <p>{{ error }}</p>
        </ui-banner>
    </div>
    <ui-card class="request-details" [withMargin]="false">
        <!--Left Pane-->
        <h2>{{ 'time-off-v3.selectDates' | translate }}</h2>
        <div class="request-details-content">
            <div>
                <div class="date-range-wrapper">
                    <mat-form-field class="custom-width-form-field margin-right-1">
                        <mat-label>{{ 'time-off-v3.startDate' | translate }}</mat-label>
                        <input matInput type="text" [value]="startAtString" readonly />
                    </mat-form-field>
                    <mat-icon svgIcon="arrowRight" class="arrow-icon"></mat-icon>
                    <mat-form-field
                        class="custom-width-form-field margin-left-1"
                        [ngClass]="{ 'custom-highlight-infix': endDateToBeSelected }"
                    >
                        <mat-label>{{ 'time-off-v3.endDate' | translate }}</mat-label>
                        <input matInput type="text" [value]="endAtString" readonly />
                    </mat-form-field>
                </div>
                <ui-inline-date-picker
                    [startAt]="timeOffRequest.startAt"
                    [startDate]="timeOffRequest.startAt"
                    [endDate]="timeOffRequest.endAt"
                    (dateRangesChange)="processRequest($event)"
                    (startDateSelectedChange)="processBeginDateSelected($event)"
                    [dateFilter]="dateFilter"
                    [canMakeSelection]="canUpdateDatePicker"
                >
                </ui-inline-date-picker>
            </div>
            <!--Right Pane-->
            <div class="request-details-items">
                <mat-form-field>
                    <mat-label appRemoveAriaOwns>{{ 'time-off-v3.selectLeaveType' | translate }}</mat-label>
                    <mat-select
                        name="timeOffType"
                        [ngModel]="selectedTimeOffPolicy.id"
                        (ngModelChange)="setPolicy($event)"
                        [disabled]="actionType === 'update' || beginDateSelected"
                    >
                        <mat-option *ngFor="let policy of activeTimeOffPolicies" [value]="policy.id">{{
                            policy.timeOffType.name
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="day-modifier" *ngIf="timeOffRequest.hasMultipleDays; else singleDayModifier">
                    <ui-button type="outline" (click)="onAdjustDailyAmounts()" [disabled]="beginDateSelected"
                        >{{ 'time-off-v3.adjustDailyAmounts' | translate }}
                    </ui-button>
                    <ui-info
                        tooltipPosition="above"
                        text="{{ 'time-off-v3.ifAnyOfYourDaysAwayAreLessThan' | translate }}"
                    ></ui-info>
                    <p>
                        <small *ngIf="weekendsCount || holidaysCount"
                            ><sup>*</sup>
                            <span
                                translate
                                [translateParams]="{
                                    days: daysMessage | translate: { count: weekendsCount || holidaysCount },
                                    and:
                                        (weekendsCount && holidaysCount ? 'time-off-v3.andWithSpaces' : '') | translate,
                                    holidays: holidaysMessage | translate: { count: holidaysCount },
                                }"
                                >time-off-v3.notCountableDaysMessage</span
                            >
                        </small>
                    </p>
                </div>
                <ng-template #singleDayModifier>
                    <app-request-day-form
                        [timeOffRequestDay]="timeOffRequestDays[0]"
                        [maxAmount]="maxAmount"
                        (update)="setTimeOffRequestDayAmount($event)"
                        #requestDayForm
                    >
                    </app-request-day-form>
                </ng-template>
                <mat-form-field [ngClass]="{ 'note-field ': timeOffRequest.hasMultipleDays }">
                    <mat-label>{{ 'time-off-v3.addDescription' | translate }}</mat-label>
                    <textarea [(ngModel)]="timeOffRequest.description" matInput [maxLength]="255"></textarea>
                </mat-form-field>

                <div class="buttons mobile-float">
                    <ui-button (click)="goBack()">{{ 'cancel' | appTranslate }}</ui-button>
                    <ui-button type="primary" (click)="onSave()" [disabled]="hasErrors || beginDateSelected">{{
                        actionType === 'create' ? ('time-off-v3.request' | translate) : ('time-off-v3.save' | translate)
                    }}</ui-button>
                </div>
            </div>
        </div>
    </ui-card>
    <!--Right-->
    <div class="summary">
        <ui-card [class.loading]="isUpdatingBalance || isSyncingTimeOffRequestDays" [withMargin]="false">
            <h2>{{ 'time-off-v3.summary' | translate }}</h2>
            <div class="vertical-labels">
                <div class="vertical-label">
                    <div>{{ 'time-off-v3.countsAs' | translate }}</div>
                    <div>
                        {{ totalAmount.toFixed(2) | i18nNum }}
                        {{ timeOffRequest.unitOfTimePluralTranslation | appTranslate | titlecase }}
                    </div>
                </div>
                <div class="vertical-label">
                    <div>{{ 'time-off-v3.balanceBefore' | translate }}</div>
                    <div *ngIf="!timeOffRequest.timeOffPolicy.isUnlimited; else infinity">
                        {{ (showHourly ? timeOffBalance.balanceHours : timeOffBalance.balance) | i18nNum }}
                        {{ timeOffRequest.unitOfTimePluralTranslation | appTranslate | titlecase }}
                    </div>
                </div>
            </div>
        </ui-card>

        <ui-card
            class="scrollable-table-container"
            *ngIf="canViewOverlaps"
            [class.loading]="isUpdatingOverlaps"
            [withMargin]="false"
        >
            <h2>{{ 'time-off-v3.overlapInDepartment' | translate }}</h2>
            <h3 class="no-overlaps" *ngIf="!overlaps.length">{{ 'time-off-v3.noOverlappingRequests' | translate }}</h3>
            <div class="overlaps-wrapper" *ngIf="overlaps.length">
                <app-avatar
                    *ngFor="let request of overlaps"
                    [employee]="request.employee"
                    [name]="true"
                    class="avatar"
                ></app-avatar>
            </div>
        </ui-card>
    </div>
</div>

<ng-template #infinity>
    <mat-icon svgIcon="infinity"></mat-icon>
</ng-template>
